import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles/ListOptionQuiz.module.css";
import { ReactSortable } from "react-sortablejs";
import clsx from "clsx";
import { Button, Form } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { useFormik } from "formik";

const ListOptionQuiz = ({
  choiceType,
  values,
  onAdd,
  onDelete,
  onChange,
  formik,
}) => {
  // state

  // variables

  // logics before hooks

  // hooks

  // logics
  const handleAddOption = () => {
    const newOptions = {
      id: uuidv4(),
      title: "",
      isCorrectAnswer: false,
      isNew: true,
      isDeleted: false,
    };
    onAdd(newOptions);
  };

  const handleDeleteOption = (id) => {
    onDelete(id);
  };

  const handleCorrectAnswer = (id, val, choiceType) => {
    const options = [...formik.values.options];
    const optionIndex = options.findIndex((option) => option.id == id);
    const option = options[optionIndex];
    if (choiceType == "checkbox") {
      options.splice(optionIndex, 1, { ...option, isCorrectAnswer: val });
      // option.isCorrectAnswer = val;
      formik.setFieldValue("options", options);
    } else {
      const newOptions = options.map((option) => {
        if (option.id == id) {
          return { ...option, isCorrectAnswer: true };
        } else {
          return { ...option, isCorrectAnswer: false };
        }
      });
      formik.setFieldValue("options", newOptions);
    }
  };

  // UI partials

  // effects

  // render
  return (
    <>
      <span>List options</span>
      <Button
        onClick={handleAddOption}
        className="my-3 ml-2"
        size="sm"
        variant="outline-danger"
      >
        Add option
      </Button>
      {/* {formik.errors.options && formik.touched.options && (
        <p className="text-danger text-center my-2">{formik.errors.options}</p>
      )} */}
      {formik.errors.options && formik.touched.options && (
        <p className="text-danger text-center my-2">
          {Array.isArray(formik.errors.options)
            ? formik.errors.options.find((option) => option?.isCorrectAnswer)
                ?.isCorrectAnswer //Casi nay ko phair laf option[0]
            : formik.errors.options}
        </p>
      )}

      {/* <ReactSortable list={[1, 2, 3]} setList={() => {}}> */}
      {values.options?.map((option, index) => {
        return (
          <>
            {!option.isDeleted && (
              <div
                key={option.id}
                className={clsx(
                  styles.option,
                  "option d-flex align-items-center justify-content-between gap-3 rounded py-2 px-3 mb-2"
                  // option.isDeleted && "d-none"
                )}
              >
                <span>
                  <i className="bi bi-list"></i>
                </span>
                <div className="flex-grow-1 position-relative">
                  <Form.Control
                    type="text"
                    placeholder="Option title"
                    className=""
                    name={`options.${index}.title`}
                    value={option?.title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.errors.options &&
                      formik.touched.options &&
                      formik.errors.options[index]?.title &&
                      formik.touched.options[index]?.title
                    }
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className="position-absolute top-50 end-0 w-auto translate-middle mt-0 mr-3"
                  >
                    {formik.errors.options &&
                      formik.errors.options[index]?.title}
                  </Form.Control.Feedback>
                </div>

                <Form.Check
                  type={choiceType}
                  id={option.id}
                  label={"Correct"}
                  name={"isCorrectAnswer"}
                  value={option.isCorrectAnswer}
                  checked={option.isCorrectAnswer}
                  onChange={(event) =>
                    handleCorrectAnswer(
                      option.id,
                      event.target.checked,
                      choiceType
                    )
                  }
                  onBlur={formik.handleBlur}
                />

                <i
                  className="bi bi-trash"
                  onClick={() => handleDeleteOption(option.id)}
                ></i>
              </div>
            )}
          </>
        );
      })}
      {/* </ReactSortable> */}
    </>
  );
};

/* required: display name */
ListOptionQuiz.displayName = "ListOptionQuiz";

/* required: props types */
ListOptionQuiz.propTypes = {};

/* required: default props */
ListOptionQuiz.defaultProps = { choiceType: "radio" };

export { ListOptionQuiz };
